/// <reference path="../../../../../../typings/index.d.ts" />
module Meevo.Plugins.RatingsControlPanel {
    import ISelectItem = Meevo.Model.ISelectItem;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import Employee = Meevo.Model.Employee;

    const PRESET_LIST = [
        { name: 'LABEL_CUSTOM', status: PresetStatus.Custom },
        { name: 'LABEL_TODAY', status: PresetStatus.Today },
        { name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday },
        { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
        { name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek },
        { name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth },
        { name: 'LABEL_LAST_MONTH', status: PresetStatus.LastMonth },
        { name: 'LABEL_THIS_QUARTER', status: PresetStatus.ThisQuarter },
        { name: 'LABEL_LAST_QUARTER', status: PresetStatus.LastQuarter },
        { name: 'LABEL_THIS_YEAR', status: PresetStatus.ThisYear },
        { name: 'LABEL_LAST_YEAR', status: PresetStatus.LastYear },
    ];

    export class MeevoRatingsControlPanelFilterComponent implements ng.IComponentController {
        static $inject = [
            'meevo.components.common.IdentityService',
        ];

        public viewChoices: ISelectItem<DataListViewTypesEnum>[];
        public ratingChoices: ISelectItem<number>[];
        public displayChoices: ISelectItem<number>[];
        public presetList = PRESET_LIST;
        public employeeSecurity: boolean;
        public clientSecurity: boolean;
        public criteria: RatingControlPanelCriteriaModel;
        public viewType: DataListViewTypesEnum;
        public serviceCriteria: IServiceCriteria = { serviceCategoryId: null };
        public employeeCriteria: IEmployeeCriteria = {
            includeActive: true,
            includeDeleted: false,
            includeInactive: false,
            showEmployeesOnly: true,
            showTerminated: false,
        };

        public get isDetailedView(): boolean {
            return this.viewType === DataListViewTypesEnum.Detailed;
        }

        public get presetStatus() {
            return PresetStatus;
        }

        public get showIncludeDeleted(): boolean {
            return this.criteria.displayType !== DisplayRatingTypesEnum.Deleted;
        }

        constructor(protected identityService: Meevo.Components.Common.IIdentityService) {
            this.viewChoices = [
                { label: 'LABEL_SUMMARY', value: DataListViewTypesEnum.Summary },
                { label: 'LABEL_DETAILED', value: DataListViewTypesEnum.Detailed },
            ];
            this.ratingChoices = [
                { label: 'All', value: null },
                { label: '1 star', value: 1 },
                { label: '2 stars', value: 2 },
                { label: '3 stars', value: 3 },
                { label: '4 stars', value: 4 },
                { label: '5 stars', value: 5 },
            ];

            this.displayChoices = [
                { label: 'LABEL_All_RATINGS', value: DisplayRatingTypesEnum.All },
                { label: 'LABEL_PUBLISHED', value: DisplayRatingTypesEnum.Published },
                { label: 'LABEL_NOT_PUBLISHED', value: DisplayRatingTypesEnum.Unpublished },
                { label: 'LABEL_DELETED', value: DisplayRatingTypesEnum.Deleted },
            ];

            this.criteria.employee = {
                id: this.identityService.current().userId.toString(),
                displayName: this.identityService.current().displayName,
            } as Employee;
        }

        public updateServiceCriteria() {
            this.serviceCriteria['serviceCategoryId'] = this.criteria.serviceCategory ? this.criteria.serviceCategory.id : null;
        }

        public ratingMap(value) {
            return value ? value : 0;
        }
    }

    angular.module('meevo.plugins.ratingsControlPanel')
        .component('meevoRatingsControlPanelFilterComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/ratingsControlPanel/components/filter/ratings-filter.component.html',
            controller: MeevoRatingsControlPanelFilterComponent,
            controllerAs: '$ctrl',
            bindings: {
                criteria: '=',
                viewType: '=',
                onSearch: '&',
                employeeSecurity: '=',
                clientSecurity: '='
            }
        });
}
